import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'csPlural' })
@Injectable({  providedIn: 'root'})
export class CzechPluralPipe implements PipeTransform {
  transform(value: number, form1: string, form2: string, form5: string): string {
    if (value === 1) return form1;
    if (value >= 2 && value <= 4) return form2;
    return form5;
  }
}
